import React from 'react';
import { useNavigate } from 'react-router-dom';
import * as yup from 'yup';
import dayjs from 'dayjs';

import { useFormik } from 'formik';
import { PartnerListBox }   from '../../components/partnermng/PartnerListBox';
import  PartnerStatusBox from '../../components/partnermng/PartnerStatusBox';

const PartnerSearchContainer = ({
  searchList,
  searchTradeTyp,
  searchPartnerTyp,
  searchKeyword,
  searchWords,
  downloadExl,
  uploadExl,
}) => {
  const navigate = useNavigate();
  const handleAdd = () => {
    navigate('/partnermng/add');
  };

  const initialValues = {
    searchTradeTyp: Array.isArray(searchTradeTyp) ? searchTradeTyp : [],
    searchPartnerTyp: searchPartnerTyp,
    searchKeyword: searchKeyword,
    searchWords: searchWords,
  };

  const validationSchema = yup.object({
    searchTradeTyp: yup.array().of(yup.string()).nullable(),
    searchPartnerTyp: yup.string().nullable(),
    searchKeyword: yup.string('').nullable(),
    searchWords: yup.string('').trim().nullable(),
  });

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values, { setSubmitting }) => {
      setSubmitting(true);
      searchList(values);
      setSubmitting(false);
    },
  });

  // PartnerStatusBox에서 토글된 값을 받으면 해당 필드를 업데이트
  const handleFilters = (key, next) => {
    formik.setFieldValue(key, next);
    // 즉시 검색하고 싶으면 여기서 formik.submitForm() 호출
  };

  
  return (
    <>
      {/* 2) PartnerListBox 렌더링 */}
      <PartnerListBox
        formik={formik}
        handleAdd={handleAdd}
        downloadExl={downloadExl}
        uploadExl={uploadExl}
      />
      {/* 1) PartnerStatusBox 렌더링: filters + onFilters */}
      <PartnerStatusBox
        filters={formik.values}
        onFilters={handleFilters}
      />

    </>
  );

};

export default PartnerSearchContainer;
